import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "b-profile-worker-page" }
const _hoisted_2 = { class: "b-profile-worker-page__head" }
const _hoisted_3 = { class: "b-profile-worker-page__title" }
const _hoisted_4 = { class: "h-flex b-workers-page h-flex-wrap" }
const _hoisted_5 = {
  key: 1,
  class: "h-width-100p"
}
const _hoisted_6 = {
  key: 0,
  class: "h-font-18"
}
const _hoisted_7 = { class: "b-profile-worker-page__wrapper" }
const _hoisted_8 = {
  key: 1,
  class: "h-font-18"
}
const _hoisted_9 = { class: "b-profile-worker-page__wrapper" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FwInput = _resolveComponent("FwInput")!
  const _component_FwSpinLoader = _resolveComponent("FwSpinLoader")!
  const _component_WorkerCard = _resolveComponent("WorkerCard")!
  const _component_FwPagination = _resolveComponent("FwPagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('LABEL.WORKERS')), 1),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_FwInput, {
          class: "h-flex-1 h-ml-15",
          value: _ctx.searchText,
          placeholder: _ctx.$t(`WORKERS.SEARCH.PLACEHOLDER`),
          iconRight: "loupe",
          iconSize: "15",
          inputStyle: "search",
          type: "search",
          onUpdate: _cache[0] || (_cache[0] = value => _ctx.searchText = value)
        }, null, 8, ["value", "placeholder"])
      ])
    ]),
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_FwSpinLoader, {
          key: 0,
          colors: ["#27dbbd", "#27DBBD", "#27DBBD"],
          class: "h-flex-center loader",
          isActive: _ctx.loading,
          className: "h-p-20"
        }, null, 8, ["isActive"]))
      : (_openBlock(), _createElementBlock("div", _hoisted_5, [
          (_ctx.confirmedUsers.length !== 0)
            ? (_openBlock(), _createElementBlock("h1", _hoisted_6, _toDisplayString(_ctx.$t('WORKER.CONFIRMED')) + " (" + _toDisplayString(_ctx.confirmedUsers.length) + ") ", 1))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_7, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.preparedWorkersCards, (worker) => {
              return (_openBlock(), _createBlock(_component_WorkerCard, {
                key: worker.id,
                worker: worker,
                class: "h-mb-20"
              }, null, 8, ["worker"]))
            }), 128))
          ]),
          (_ctx.unconfirmedUsers.length !== 0)
            ? (_openBlock(), _createElementBlock("h1", _hoisted_8, _toDisplayString(_ctx.$t('WORKER.UNCONFIRMED')) + " (" + _toDisplayString(_ctx.unconfirmedUsers.length) + ") ", 1))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_9, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.preparedWorkersCards, (worker) => {
              return (_openBlock(), _createBlock(_component_WorkerCard, {
                key: worker.id,
                worker: worker,
                class: "h-mb-20"
              }, null, 8, ["worker"]))
            }), 128))
          ]),
          (_ctx.totalPage > _ctx.perPage)
            ? (_openBlock(), _createBlock(_component_FwPagination, {
                key: 2,
                totalPage: _ctx.totalPage,
                currentPage: _ctx.currentPage,
                perPage: _ctx.perPage,
                value: _ctx.perPage,
                onGetData: _ctx.getWorkersList
              }, null, 8, ["totalPage", "currentPage", "perPage", "value", "onGetData"]))
            : _createCommentVNode("", true)
        ]))
  ]))
}